import { makeObservable, observable, action } from 'mobx';

var TotalBetStore = /** @class */ (function () {
    // totalBetForNote = 0;
    function TotalBetStore() {
        this.totalBet = 0;
        this.totalWinAmount = 0;
        makeObservable(this, {
            totalBet: observable,
            totalWinAmount: observable,
            // totalBetForNote: observable,
            setTotalBet: action.bound,
            setTotalWinAmount: action.bound,
            // setTotalBetForNote: action.bound,
        });
    }
    TotalBetStore.prototype.setTotalWinAmount = function (amount) {
        if (amount || amount === 0) {
            this.totalWinAmount += amount;
        }
        else {
            this.totalWinAmount = amount;
        }
    };
    TotalBetStore.prototype.setTotalBet = function (totalBetAmount) {
        if (totalBetAmount) {
            this.totalBet += totalBetAmount;
        }
        else {
            this.totalBet = totalBetAmount;
        }
    };
    return TotalBetStore;
}());
var totalBetStore = new TotalBetStore();

export { totalBetStore };
